import React, { useState } from 'react';

import Loader from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faExternalLinkAlt, faPen, faCircle } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../../firebase';
import FileUploader from 'react-firebase-file-uploader';
import ModalConfirm from '../../useful/ModalConfirm';
import { withRouter } from 'react-router-dom';

const AdItem = (props) => {

    const [deleting, setDeleting] = useState(false);
    const [confirmModal, setConfirmModal] = useState({ show: false, title: '', message: '' });
    const [uploadingLogo, setUploadingLogo] = useState(false);
    const { ad, showAdEditForm } = props;

    const deleteAd = () => {
        setConfirmModal({ show: false, title: '', message: '' })
        if (ad && ad.uid) {
            setDeleting(true);
            const deleteAdFuntion = props.firebase.deleteAd();

            deleteAdFuntion({ uid: ad.uid, fileName: ad.fileName })
                .then((result) => {
                    setDeleting(false);
                    if (result.data && result.data.code && result.data.code === 200) {
                        props.showModal("Info", "La publicidad se eliminó con éxito");
                    } else {
                        props.showModal("Error", "No se pudo eliminar la publicidad");
                    }
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    setDeleting(false);
                    props.showModal("Error", "No se pudo eliminar la publicidad");
                });
        }

    }

    const showConfirmModal = () => {
        setConfirmModal({ show: true, title: 'Eliminar publicidad', message: 'Está seguro de eliminar este elemento?' });
    }

    const handleUploadStart = () => {
        setUploadingLogo(true)
    }

    const handleUploadError = (error) => {
        setUploadingLogo(false)
        props.showModal("Error", "Los sentimos, ocurrió un error al subir el archivo.");
    };

    const handleUploadSuccess = filename => {

        props.firebase.file('ads', filename).getDownloadURL()
            .then(fileUrl => {
                ad.imageUrl = fileUrl
                setUploadingLogo(false)
                props.firebase.adsDoc(ad.uid).update({
                    imageUrl: fileUrl,
                    fileName: filename
                }).catch((error) => {
                    setUploadingLogo(false)
                    console.log("Error: ", error);
                    props.showModal("Error", "Los sentimos, ocurrió un error al subir el archivo.");
                });
            });
    };


    const color = ad && ad.blocked ? '#f88b97' : '#87f892';
    // const shortUrl = ad.url.length < 20 ? ad.url : ad.url.substring(0, 30) + " ...";
    const shortUrl = ad.url;


    const fileName = ad.title + "_" + ad.uid;
    const filesRef = props.firebase.folder('ads');
    const imageUrl = (ad && ad.imageUrl) ? ad.imageUrl : process.env.PUBLIC_URL + "/ad_none.png";
    const uploadImageText = (ad && ad.imageUrl) ? "Cambiar Imagen" : "Seleccionar Imagen";
    const borderClass = ad.blocked ? "bg-danger" : "";

    return (

        <div className={"row m-0 w-100 bg-white rounded-lg mb-2 border " + borderClass}>

            <div className="col-12 col-md-4 col-lg-4 p-0 w-100" width="100%" style={{ height: 100 }} >
                {(!uploadingLogo) ?
                    <label className="btn btn-sm m-0 p-0 border-0 w-100" >
                        <div className="position-relative" >
                            <div className="rounded-ads" style={{
                                backgroundImage: `url(${imageUrl})`,
                                height: 100,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat'
                            }} width="100%" alt="Ad image" />
                            <span className=" bg-second-transparent rounded-lg p-1 small text-dark position-absolute bottom-center">
                                <FontAwesomeIcon className="mr-1" size="sm" icon={faPen} />
                                <span>{uploadImageText}</span>
                            </span>
                        </div>
                        <FileUploader
                            hidden
                            accept="image/*"
                            name="file"
                            filename={fileName}
                            storageRef={filesRef}
                            onUploadStart={handleUploadStart}
                            onUploadError={handleUploadError}
                            onUploadSuccess={handleUploadSuccess}
                        />
                    </label>
                    :
                    <div className="d-flex bg-second-transparent rounded-ads justify-content-center align-items-center" style={{ height: 100 }}>
                        <Loader className=" m-2"
                            type="ThreeDots"
                            color="#263238"
                            height={30}
                            width={50}
                            timeout={0} />
                    </div>
                }
            </div>

            <div className="col-12 col-md-8 col-lg-8 d-flex flex-column pr-2 pt-2 pl-2 pb-1">
                <span className="small font-weight-bold mb-1">
                    <FontAwesomeIcon className="mr-2" color={color} size="lg" icon={faCircle} />
                    {ad.title}
                </span>
                <a href={ad.url} className="card-link text-primary" target="_blank" rel="noopener noreferrer">
                    {/* <FontAwesomeIcon className="mr-1" size="sm" icon={faExternalLinkAlt} /> */}
                    <span className="small d-inline-block text-truncate" style={{ width: 100 + '%' }}>{shortUrl}</span>
                </a>
                <div className="d-flex flex-fill justify-content-end align-items-end">
                    <div className="border-top d-flex flex-fill justify-content-end pt-1">
                        {!deleting ?
                            <>
                                <button onClick={showConfirmModal} className="btn btn-sm btn-outline-danger border-0 ml-1 mr-1" >Eliminar</button>
                                <button onClick={() => showAdEditForm(ad)} type="submit" className="btn btn-sm btn-outline-success border-0 ml-1 mr-0" >Editar</button>
                            </>
                            :
                            <Loader className=""
                                type="ThreeDots"
                                color="#263238"
                                height={29}
                                width={50}
                                timeout={0} />
                        }
                    </div>
                </div>
            </div>

            <ModalConfirm
                data={confirmModal}
                onClose={() => setConfirmModal({ show: false, title: '', message: '' })}
                onConfirm={deleteAd}
            />

        </div >


    )


}

export default withRouter(withFirebase(AdItem));
